export default "__VITE_ASSET__DrMe99eR__"